import { Tag } from 'antd';
import type { TagProps } from 'antd';

export interface DTagProps extends TagProps {}

export const DarwinTag = (props: DTagProps) => {
  return <Tag {...props} />;
};
